/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import RadioInput from '../RadioInput';
import styles from './index.styl';

const ScaleInput = ({ opacity, ...other }) => (
  <div styleName="itemWrapper">
    <div styleName="item">
      <div styleName="itemBg" style={{ ...{ opacity } }} />
      <RadioInput vertical {...other} />
    </div>
  </div>
);

ScaleInput.propTypes = {
  opacity: PropTypes.number,
};

export default CSSModules(ScaleInput, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/ScaleRange/ScaleInput.jsx